import packageJson from "../../package.json";

export const addVersionToHTML = () =>
  document.documentElement.prepend(document.createComment(`v${packageJson.version}`));
